/**
 * Schemas for `GET /admin/dashboard/sdr-comparison` — Story 12.9 (Epic E12).
 *
 * `admin`/`manager` only — comparativo lado a lado do volume/atividade de
 * cada carteira de SDR. Deliberadamente um endpoint dedicado, não uma seção
 * da resposta de `GET /admin/dashboard/kpis` (decisão fechada na validação
 * @po de `docs/stories/12.9.story.md`): isola o RBAC sem risco de vazar o
 * campo pra uma resposta que `sdr` também consome.
 */
import { Type } from '@sinclair/typebox';
export const DashboardSdrComparisonQuery = Type.Object({
    from: Type.Optional(Type.String({ format: 'date-time' })),
    to: Type.Optional(Type.String({ format: 'date-time' })),
});
/**
 * Uma linha por SDR candidata — SDRs ativas (mesmo com zero leads no
 * período, pra não esconder quem está ociosa) UNION SDRs desativadas que
 * têm pelo menos 1 lead no período (AC5 — dado real nunca desaparece por
 * status administrativo do usuário, mesmo espírito do `ON DELETE SET NULL`
 * da Story 12.1).
 */
const SdrComparisonRow = Type.Object({
    sdrId: Type.String({ format: 'uuid' }),
    sdrName: Type.String(),
    sdrActive: Type.Boolean(),
    leadsReceived: Type.Integer({ minimum: 0 }),
    activeConversations: Type.Integer({ minimum: 0 }),
    meetingsScheduled: Type.Integer({ minimum: 0 }),
    responseRate: Type.Union([Type.Number(), Type.Null()]),
});
export const DashboardSdrComparisonResponse = Type.Object({
    period: Type.Object({
        from: Type.String({ format: 'date-time' }),
        to: Type.String({ format: 'date-time' }),
    }),
    rows: Type.Array(SdrComparisonRow),
});
//# sourceMappingURL=dashboard-sdr-comparison.js.map